import { produce } from "immer";
import api from "../../api";

const utils = (context) => {
  const { dispatch, current, designId, rootState, rootGetters } = context;

  return {
    async removeCells(condition) {
      const cellIdsForRemove = [];

      current.design.cellsMetaData = produce(current.design.cellsMetaData, (cellsMetaData) => {
        Object.keys(cellsMetaData).forEach((key) => {
          if (condition(key)) {
            cellIdsForRemove.push(key);
            delete cellsMetaData[key]; // Remove the cell from the cellsMetaData
          }
        });
      });

      const sheetName = rootState.sheets.currentSheet.name;
      await api.patch(`designs/${designId}/remove-cells`, { sheetName, cellIdsForRemove });
    },
    removeFormulaMetaData(range) {
      let cellIds = rootGetters["cells/rangeIds"](range).filter((id) => !rootGetters["cells/isCellDisabled"](id));
      current.design.cellsMetaData = produce(current.design.cellsMetaData, (cellsMetaData) => {
        cellIds.forEach((id) => {
          if (cellsMetaData[id]?.formula) {
            delete cellsMetaData[id].formula;
          }
        });
      });
      dispatch("toggleRedrawCanvas");
      dispatch("persistCellsMetaData", cellIds);
    },
  };
};

const main = (context) => {
  const { dispatch, rootGetters, current } = context;
  return {
    remove(range) {
      const rowIds = rootGetters["cells/rowsInRange"](range);

      const rowIdSet = new Set(rowIds);
      let prevCellsMetaData = {};
      Object.entries(current.design.cellsMetaData).forEach(([key, value]) => {
        if (rowIdSet.has(key.split("_")[0])) prevCellsMetaData[key] = value;
      });
      utils(context).removeCells((cellId) => rowIdSet.has(cellId.split("_")[0]), { root: true });
      return () => {
        current.design.cellsMetaData = { ...current.design.cellsMetaData, ...prevCellsMetaData };
      };
    },
    async removeProperty(cellIds, key) {
      let prevCellsMetaData = {};

      current.design.cellsMetaData = produce(current.design.cellsMetaData, (cellsMetaData) => {
        cellIds.forEach((id) => {
          if (cellsMetaData[id]) {
            prevCellsMetaData[id] = current.design.cellsMetaData[id];
            delete cellsMetaData[id][key]; // Remove the key from the cell's metadata
          }
        });
      });
      await dispatch("persistCellsMetaData", cellIds);

      return async () => {
        current.design.cellsMetaData = { ...current.design.cellsMetaData, ...prevCellsMetaData };
        await dispatch("persistCellsMetaData", cellIds);
      };
    },
    async removeComment(cellIds, key) {
      let prevCellsMetaData = {};

      current.design.cellsMetaData = produce(current.design.cellsMetaData, (cellsMetaData) => {
        cellIds.forEach((id) => {
          if (cellsMetaData[id]) {
            prevCellsMetaData[id] = current.design.cellsMetaData[id];
            delete cellsMetaData[id][key]; // Remove the key from the cell's metadata
          }
        });
      });
      await dispatch("persistCellsComment", cellIds);

      return async () => {
        current.design.cellsMetaData = { ...current.design.cellsMetaData, ...prevCellsMetaData };
        await dispatch("persistCellsComment", cellIds);
      };
    },
    async edit(id, key, value) {
      let prevCellMetaData = {};

      current.design.cellsMetaData = produce(current.design.cellsMetaData, (cellsMetaData) => {
        if (!cellsMetaData[id]) {
          cellsMetaData[id] = {}; // Ensure the id key exists
        }
        prevCellMetaData = { ...cellsMetaData[id] };
        cellsMetaData[id][key] = value; // Update the key with the new value
      });

      dispatch("cells/toggleRedrawCanvas", null, { root: true });
      await dispatch("persistCellsMetaData", id);

      return async () => {
        current.design.cellsMetaData = produce(current.design.cellsMetaData, (cellsMetaData) => {
          cellsMetaData[id] = prevCellMetaData;
        });
        dispatch("cells/toggleRedrawCanvas", null, { root: true });
        await dispatch("persistCellsMetaData", id);
      };
    },
  };
};
export default (context) => {
  return {
    main: main(context),
    utils: utils(context),
  };
};
